import { render, staticRenderFns } from "./CollectionFilterControlTypeUrl.vue?vue&type=template&id=b00fc2f2"
import script from "./CollectionFilterControlTypeUrl.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeUrl.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports